import styled from '@emotion/styled';
import { claudeTokens } from '@/styles/claudeTokens';
import BannerCarousel from '@/components/common/organism/BannerCarousel';

export interface ListBanner {
    id: number;
    type?: string;
    title?: string;
    imageUrl: string;
    mobileImageUrl?: string | null;
    linkUrl?: string | null;
}

const Stack = styled.div<{ placement: 'top' | 'bottom' }>`
    margin: ${p => p.placement === 'top' ? '24px' : '16px'} 0 ${p => p.placement === 'top' ? '16px' : '0'};
    @media (max-width: 768px) {
        margin: ${p => p.placement === 'top' ? '12px' : '8px'} 0 ${p => p.placement === 'top' ? '8px' : '0'};
    }
`;

/** 배너 한 자리의 틀 — 4:1, 반경 md. 여러 장이면 이 틀 안에서 가로로 넘긴다(2026-10-12 사용자 확정) */
export const BannerFrame = styled.div`
    width: 100%;
    aspect-ratio: 4 / 1;
    border-radius: ${claudeTokens.radius.md};
    overflow: hidden;
    /* 넘기는 동안 둥근 모서리 밖으로 그림이 비치지 않게(사파리) */
    isolation: isolate;
`;

/**
 * 목록 배너 — 간격은 여기서만 관리한다. 필터가 있는 목록의 상단 배너는 필터 뒤, 하단은 목록/페이지 이동 뒤에 배치한다.
 * 한 자리에 여러 장이면 세로로 쌓지 않고 홈 메인 배너와 같은 넘김(BannerCarousel)으로 보여 준다. 없으면 자리도 없다.
 */
export default function ListBanners({ banners, placement }: { banners: ListBanner[]; placement: 'top' | 'bottom' }) {
    const visible = banners.filter(b => b.imageUrl);
    if (!visible.length) return null;
    return <Stack placement={placement} data-list-banners={placement}>
        <BannerFrame><BannerCarousel banners={visible} noSwipeBack /></BannerFrame>
    </Stack>;
}
